export enum QuadrantType {
  VERSION_ONE = "version_one",
  VERSION_TWO = "version_two",
  VERSION_THREE = "version_three",
}

export interface QuadrantLayoutConfig {
  id: string
  x: number
  y: number
  width: number
  height: number
}

export const getQuadrantLayouts = (type: QuadrantType): QuadrantLayoutConfig[] => {
  switch (type) {
    case QuadrantType.VERSION_ONE:
      return [
        { id: "role", x: 0, y: 0, width: 470, height: 470 },
        { id: "activities", x: 480, y: 0, width: 470, height: 470 },
        { id: "levels", x: 960, y: 0, width: 950, height: 470 },
        { id: "positive-points", x: 0, y: 480, width: 630, height: 470 },
        { id: "negative-points", x: 640, y: 480, width: 630, height: 470 },
        { id: "improvement-actions", x: 1280, y: 480, width: 630, height: 470 }
      ]

    case QuadrantType.VERSION_TWO:
      return [
        { id: "levels", x: 0, y: 0, width: 1910, height: 470 },
        { id: "positive-points", x: 0, y: 480, width: 630, height: 470 },
        { id: "negative-points", x: 640, y: 480, width: 630, height: 470 },
        { id: "improvement-actions", x: 1280, y: 480, width: 630, height: 470 },
      ]

    case QuadrantType.VERSION_THREE:
    default:
      return [
        { id: "role", x: 0, y: 0, width: 130, height: 470 },
        { id: "activities", x: 140, y: 0, width: 450, height: 470 },
        { id: "expected-results", x: 600, y: 0, width: 470, height: 470 },
        { id: "levels", x: 1080, y: 0, width: 839, height: 470 },
        { id: "positive-points", x: 0, y: 480, width: 470, height: 470 },
        { id: "negative-points", x: 480, y: 480, width: 480, height: 470 },
        { id: "improvement-actions", x: 970, y: 480, width: 470, height: 470 },
        { id: "feelings", x: 1450, y: 480, width: 470, height: 470 },
      ]
  }
}
